import { LANGUAGES } from "@/shared";

export const LANGUAGES_ARRAY = [
  {
    id: LANGUAGES.English,
    text: "English",
    momentLocale: "en"
  },
  {
    id: LANGUAGES.Lithuanian,
    text: "Lietuvių",
    momentLocale: "lt"
  },
  {
    id: LANGUAGES.Spanish,
    text: "Español",
    momentLocale: "es"
  },
  {
    id: LANGUAGES.German,
    text: "Deutsch",
    momentLocale: "de"
  },
  {
    id: LANGUAGES.French,
    text: "Français",
    momentLocale: "fr"
  },
  {
    id: LANGUAGES.Italian,
    text: "Italiano",
    momentLocale: "it"
  },
  {
    id: LANGUAGES.Polish,
    text: "Polski",
    momentLocale: "pl"
  },
  {
    id: LANGUAGES.Hungarian,
    text: "Magyar",
    momentLocale: "hu"
  }
];
